import { d as dateToString } from './index3.js';

// jQuery Datepicker
function getDateFromJqueryDatepicker(selector, jQuery) {
  // needs jQuery
  if (!jQuery || !jQuery.fn.datepicker) {
    throw Error('jQuery or Datepicker missing');
  }
  // get date
  const date = jQuery(selector).datepicker('getDate');
  if (!date || (Object.prototype.hasOwnProperty.call(date, 'length') && date.length === 0)) {
    return undefined;
  }
  return date;
}

// Bootstrap Datepicker
function getDateFromBootstrapDatepicker(selector, jQuery) {
  // needs jQuery
  if (!jQuery || !jQuery.fn.datepicker) {
    throw new Error('jQuery or Datepicker missing');
  }
  // get date
  const date = jQuery(selector).data('datepicker').getDate();
  if (!date || (Object.prototype.hasOwnProperty.call(date, 'length') && date.length === 0)) {
    return undefined;
  }
  return date;
}

// Pickadate Datepicker
function getDateFromPickadateDatepicker(selector, jQuery) {
  // needs jQuery
  if (!jQuery || !jQuery.fn.pickadate) {
    throw new Error('jQuery or Pickadate missing');
  }
  // get date
  let date = jQuery(selector).pickadate('picker');
  date = date && date.get('select').obj;
  if (!date || (Object.prototype.hasOwnProperty.call(date, 'length') && date.length === 0)) {
    return undefined;
  }
  return date;
}

function getDateFromDatepicker(selector, options) {

  // defaults
  options = options || {};
  options.type = options.type || 'jquery';
  if (options.raw !== true) {
    options.raw = false;
  }

  // needs jQuery
  const $ = options.jQuery || globalThis.jQuery;

  // date
  let date;

  switch (options.type) {
    case 'bootstrap':
      date = getDateFromBootstrapDatepicker(selector, $);
      break;
    case 'pickadate':
      date = getDateFromPickadateDatepicker(selector, $);
      break;
    case 'jquery':
    default:
      date = getDateFromJqueryDatepicker(selector, $);
      break;
  }

  if (date && options.raw === false) {
    // as thn string
    date = dateToString(date);
  }

  return date;
}

export { getDateFromDatepicker as g };
